import React from "react";
import l from "components/util/l";
import moment from "moment";
import PaginationFooter from "components/util/helpers/PaginationFooter";
import "styles/css/presentation/ChatHistory.css";

const ChatHistoryView = ({
  chats,
  chat,
  pageNum,
  totalPages,
  setPageNum,
  onClickChangeChat,
}) => (
  <div className="px-1">
    <div className="w-100 px-3 px-sm-4 h-100 pb-4">

      <h2 className="pt-1 pb-3">Chats</h2>

      <div className="list-group">

          {chats.length == 0 &&
            <div id="no-data-content" className="text-center my-10 h-100">
              <i className="fas fa-comments mb-5 fa-3x"></i><br />
              <h3 className="text-muted d-inline-block">
                <div className="mb-0">{l("No tienes chats previos registrados%PA163")}</div>
                <small>{l("Envía un mensaje para iniciar un nuevo chat%PA164")}</small>
              </h3>
            </div>}

          {
            chats.map(historyChat =>
              <div
                key={`chat-${historyChat.id}`}
                class="chat-history-item list-group-item mb-1 d-flex justify-content-between align-items-center pr-2 pl-1 w-100"
              >
                <div className="d-flex align-items-center w-100 justify-content-between px-1">
                  <div>
                    <div className="d-flex align-items-start mx-3 pb-1 w-100 text-truncate">
                      <i className="chat-history-item-icon fa fa-message mr-3" />
                      <div>
                        <h5 className="text-truncate mt-1 mb-1 text-wrap mr-3">
                          {historyChat?.title ?? "Mensaje inicial"}
                        </h5>
                        <label className="chat-history-item-name">
                          {historyChat.user.firstName} {historyChat.user.lastName}<br />
                        </label>
                        <label className="chat-history-item-date">
                          {moment(historyChat.createdAt).format("DD.MMM - HH:mm")}
                        </label>
                      </div>
                    </div>
                  </div>

                  {
                    chat.id != historyChat.id &&
                    <button
                      className="chat-history-item-btn btn btn-sm btn-outline-primary mb-1 mr-2"
                      onClick={() => onClickChangeChat(historyChat)}
                    >
                      {l("Ver chat%PA044")}
                    </button>
                  }
                  {
                    chat.id == historyChat.id &&
                    <div className="chat-history-item-active-btn btn btn-sm btn-link mb-1 mr-2">
                      {l("Chat activo%PA043")}
                    </div>
                  }
                </div>
              </div>
            )
          }

    
      </div>

      {
        chats.length > 0 &&
          <PaginationFooter
            pageNum={pageNum}
            totalPages={totalPages}
            onClickPage={setPageNum}
          />
      }

    </div>
  </div>
);

export default ChatHistoryView;